/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum CloudStorageSpaceMode {
    AllocatedSpaceMode = 0,
    ConsumedSpaceMode = 1,
    GranularSpaceMode = 3,
}
